import React from 'react';

import KLine from '@widget/trade/KLine'

import { KLineHeader } from '../KLineHeader'

import styles from './index.module.css';

export const KLineWeb = (props) => {
  return (
    <div className={styles.wrapper}>
      <KLineHeader className={styles.header} {...props.kLineHeaderProps} />
      <div className={styles.main}>
        <KLine coinCode={props.coinCode} precision={props.precision} />
      </div>
    </div>
  )
}
